import React from 'react';
import ViewGmpCourseTaskList from '../../../features/GMPCourseProvider/ViewGmpCourseTaskList';

const GmpCourseTaskList = () =>
{
    return (
        <div>
            <ViewGmpCourseTaskList />
        </div>
    );
};

export default GmpCourseTaskList;
